import { render, staticRenderFns } from "./RecycleBin.vue?vue&type=template&id=5ccb339a&"
import script from "./RecycleBin.vue?vue&type=script&lang=js&"
export * from "./RecycleBin.vue?vue&type=script&lang=js&"
import style0 from "./RecycleBin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports